import styles from './index.module.scss';
import { useGlobal } from '@/utils/useGlobal';
import EFPic from '@/components/UI/EFPic';
import EFNPlay from '@/components/UI/svg/LandingPage/EFNPlay';
import EFVideoModal from '@/components/UI/EFVideoModal';
import { Pagination } from 'swiper';
import { Swiper, SwiperSlide } from 'swiper/react';

const EcoflowUsers: React.FC = () => {
    const { useLang, useState, useRouter, gtm } = useGlobal();
    const { t } = useLang('wholehome');
    const { locale } = useRouter();
    const [showVideo, setShowVideo] = useState(false);
    const [videoSource, setVideoSource] = useState('');
    const videoLists = [
        {
            source: 'https://www.youtube.com/embed/JcKq6neGxXk?si=leKqBnkHVezJuNA-',
            desc: 'secL_card5',
            poster: [
                'https://websiteoss.ecoflow.com/img/landingPage/da87b0f4781b6333bc7526327a87160b.jpg',
                'https://websiteoss.ecoflow.com/img/landingPage/da87b0f4781b6333bc7526327a87160b.jpg',
            ],
        },
        {
            source: 'https://www.youtube.com/embed/_zYHtNnuO-A?si=nRQPeg0JqmOFgqKL',
            desc: 'secL_card6',
            poster: [
                'https://websiteoss.ecoflow.com/img/landingPage/5301e4b4956e71a05856ecbdc270d84e.jpg',
                'https://websiteoss.ecoflow.com/img/landingPage/5301e4b4956e71a05856ecbdc270d84e.jpg',
            ],
        },
        {
            source: 'https://www.youtube.com/embed/Uat1fPVoR4w',
            desc: 'secL_card1',
            poster: [
                'https://websiteoss.ecoflow.com/img/landingPage/d36d54a6c0cb88db587a9ec1f579e680.jpg',
                'https://websiteoss.ecoflow.com/img/landingPage/d36d54a6c0cb88db587a9ec1f579e680.jpg',
            ],
        },
        {
            source: 'https://www.youtube.com/embed/bXd-aP06lug',
            desc: 'secL_card2',
            poster: [
                'https://websiteoss.ecoflow.com/img/landingPage/c744ebbbb4f306ddff9ae975183d8d0e.jpg',
                'https://websiteoss.ecoflow.com/img/landingPage/c744ebbbb4f306ddff9ae975183d8d0e.jpg',
            ],
        },
        {
            source: 'https://www.youtube.com/embed/ddI0e46Dbb0',
            desc: 'secL_card3',
            poster: [
                'https://websiteoss.ecoflow.com/img/landingPage/0892f679fb25fcd09f2920a4c2900034.jpg',
                'https://websiteoss.ecoflow.com/img/landingPage/0892f679fb25fcd09f2920a4c2900034.jpg',
            ],
        },
        {
            source: 'https://www.youtube.com/embed/yNBXE3BszEM',
            desc: 'secL_card4',
            poster: [
                'https://websiteoss.ecoflow.com/img/landingPage/9eb2607629894ed527cd96e25076f58f.jpg',
                'https://websiteoss.ecoflow.com/img/landingPage/9eb2607629894ed527cd96e25076f58f.jpg',
            ],
        },
    ];

    const itemHtml = (item, index: number) => {
        return (
            <div
                className="card-list"
                key={index}
                onClick={() => {
                    try {
                        // GA埋点
                        gtm.push({
                            event: 'uaEvent',
                            event_name: 'video',
                            title_name: t(item.desc),
                            position: `Solution Page_${index + 1}`,
                        });
                        // fb埋点
                        // window?.fbq && window?.fbq('track', 'Search');
                    } catch (e) {
                        console.log(e);
                    }
                    setVideoSource(item.source);
                    setShowVideo(true);
                }}
            >
                <div className="video-img-box">
                    <EFPic src={item.poster} className="video-img" />
                    <div className="mask"></div>
                    <EFNPlay className="video-play-icon" />
                </div>
                <div className="video-desc">{t(item.desc)}</div>
            </div>
        );
    };

    return (
        <div className={styles.EcoflowUsers}>
            <div className="title">{t('secL_title')}</div>
            <div className="desc">{t('secL_desc')}</div>
            <div className="card-lists pc">{videoLists.map((item: any, index: number) => itemHtml(item, index))}</div>
            <div className="card-lists h5">
                <Swiper
                    slidesPerView={1}
                    spaceBetween={20}
                    pagination={{
                        clickable: true,
                    }}
                    modules={[Pagination]}
                >
                    {videoLists.map((item: any, index: number) => {
                        return (
                            <SwiperSlide className="wrapper-item" key={item.label}>
                                {itemHtml(item, index)}
                            </SwiperSlide>
                        );
                    })}
                </Swiper>
            </div>
            {videoSource && showVideo && (
                <EFVideoModal
                    visible={showVideo}
                    source={videoSource}
                    onClose={() => setShowVideo(false)}
                    playerType={locale === 'cn' ? 'Alibaba' : 'YouTube'}
                />
            )}
        </div>
    );
};

export default EcoflowUsers;
